<!-- room type detail-->
<template>
  <transition name="fade">
    <div class="position-relative z-index-1045">
      <div class="row no-gutters justify-content-center">
        <div class="fixed-bottom d-table w-100 nav-bottom" style="top:40px">
          <div class="custom-container-fluid px-0">
            <div class="row justify-content-center no-gutters">
              <div class="col-10 position-relative" :class="{'col-lg-4':detail_room_type.image == ''}">
                <div class="rounded-4" style="height: 90vh;">
                  <div class="">
                    <div class="row no-gutters">
                      <div class="col-7 col-lg-8" v-if="detail_room_type.image != ''">
                        <div class="w-100 position-relative">
                          <flickity ref="flickity" class="room-detail text-center" :options="flickityOptionsRoom">
                            <div class="carousel-cell w-100" v-for="data_image in detail_room_type.image">
                              <div class="w-100 position-relative bg-dark-transparent" style="height: 90vh !important;">
                                <img :src="data_image.image_url" class="position-relative z-index-1045" style="object-fit:contain !important; height:100%;width:100%;">
                                <div class="position-absolute w-100 z-index-1042 bg-blur-overlay" :style="{ backgroundImage: `url('${data_image.image_url}')` }"></div>
                              </div>
                            </div>
                          </flickity>

                          <div class="slider-action-btn prev" @click="slideTheSlider('prev')">
                            <svg class="transform-180" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <circle cx="16" cy="16" r="15.5" transform="rotate(-180 16 16)" fill="white" stroke="#D9D9D9"/>
                              <path d="M19.7224 15.9731C19.7224 15.7914 19.6497 15.6097 19.5116 15.4861L13.747 9.85954C13.6234 9.73598 13.4635 9.66327 13.2817 9.66327C12.9037 9.66327 12.6129 9.94682 12.6129 10.3248C12.6129 10.5065 12.6856 10.6737 12.8019 10.7973L18.4939 16.3657V15.5879L12.8019 21.1562C12.6856 21.2725 12.6129 21.4397 12.6129 21.6287C12.6129 22.0067 12.9037 22.2903 13.2817 22.2903C13.4635 22.2903 13.6234 22.2176 13.7542 22.094L19.5116 16.4675C19.6497 16.3293 19.7224 16.1621 19.7224 15.9731Z" fill="black" fill-opacity="0.85"/>
                            </svg>
                          </div>
                          <div class="slider-action-btn next" @click="slideTheSlider('next')">
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <circle cx="16" cy="16" r="15.5" transform="rotate(-180 16 16)" fill="white" stroke="#D9D9D9"/>
                              <path d="M19.7224 15.9731C19.7224 15.7914 19.6497 15.6097 19.5116 15.4861L13.747 9.85954C13.6234 9.73598 13.4635 9.66327 13.2817 9.66327C12.9037 9.66327 12.6129 9.94682 12.6129 10.3248C12.6129 10.5065 12.6856 10.6737 12.8019 10.7973L18.4939 16.3657V15.5879L12.8019 21.1562C12.6856 21.2725 12.6129 21.4397 12.6129 21.6287C12.6129 22.0067 12.9037 22.2903 13.2817 22.2903C13.4635 22.2903 13.6234 22.2176 13.7542 22.094L19.5116 16.4675C19.6497 16.3293 19.7224 16.1621 19.7224 15.9731Z" fill="black" fill-opacity="0.85"/>
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div class="col-5 col-lg-4 position-relative" :class="{'col-lg-12':detail_room_type.image == ''}">
                        <div class="w-100 bg-white" style="overflow-y: scroll;height: 90vh;">
                          <img src="../../../../assets/img/icon/cancel.png"
                            class="d-inline-block p-2 rounded-3 bg-back mt-3 mx-4 cursor-pointer position-absolute"
                            width="33" style="z-index: 1038;right: 0" @click="onBack('detailRoom', false);onBack('handlePopupFilter', false)">
                          <div class="py-4">
                            <div class="container px-4">
                              <!-- ROOM TYPE NAME -->
                              <p class="mb-4 body-1-4 text-22 w-90">{{detail_room_type.name}}</p>

                              <!-- DESCRIPTION -->
                              <div class="mb-4" v-if="!(detail_room_type.description == null || detail_room_type.description == '')">
                                <p class="mb-1 body-1-4">{{$t('general.description')}}</p>
                                <p class="mb-4 body-2-2 html-desc multiline-text" v-html="detail_room_type.description"></p>
                              </div>

                              <!-- ROOM INFORMATION -->
                              <div class="border-semi-grey p-3 rounded-4 mb-4">
                                <div class="row slim-grid-row">
                                  <div class="col-6 mb-3" v-if="!(detail_room_type.room_size == null || detail_room_type.room_size == '' || detail_room_type.room_size == 0)">
                                    <p class="mb-0 body-3 lh-1">{{$t('hotel.unit-type.'+detail_room_type.type+'.size')}}</p>
                                    <div class="w-100">
                                      <i class="simple-icon-size-fullscreen text-green text-14 d-inline-block align-middle mr-1 font-weight-bold"></i>
                                      <p class="mb-0 body-2-1 d-inline-block align-middle">{{detail_room_type.room_size}}m²</p>
                                    </div>
                                  </div>
                                  <div class="col-6 mb-3" v-if="!(detail_room_type.total_rooms == null || detail_room_type.total_rooms == '' || detail_room_type.total_rooms == 0)">
                                    <p class="mb-0 body-3 lh-1">{{$t('hotel.room-type.total-unit')}}</p>
                                    <div class="w-100">
                                      <i class="simple-icon-home text-green text-14 d-inline-block align-middle mr-1 font-weight-bold"></i>
                                      <p class="mb-0 body-2-1 d-inline-block align-middle">{{detail_room_type.total_rooms}} {{$pluralWord(detail_room_type.total_rooms,'Room')}}</p>
                                    </div>
                                  </div>
                                  <div class="col-12" v-if="detail_room_type.bed.length > 0">
                                    <p class="mb-0 body-3 lh-1">{{$t('hotel.room-type.bed-type')}}</p>
                                    <div class="w-100">
                                      <i class="simple-icon-grid text-green text-14 d-inline-block align-middle mr-1 font-weight-bold"></i>
                                      <p class="mb-0 body-2-1 d-inline-block align-middle">
                                        <template v-for="(bed, index) in detail_room_type.bed">
                                          {{bed.qty}} {{bed.name}}
                                          <span v-if="index + 1 < detail_room_type.bed.length">, </span>
                                        </template>
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>


                              <div class="row slim-grid-row mb-4" v-if="detail_room_type.max_adults > 0 || detail_room_type.max_children > 0 || detail_room_type.max_infant > 0">
                                <div class="col-12 mb-2">
                                  <p class="mb-0 body-1-4">{{$t('hotel.room-type.recommended-occupancy')}}</p>
                                </div>
                                <div class="col-4" v-if="detail_room_type.max_adults > 0">
                                  <p class="mb-0 body-3 lh-1">{{$t('hotel.adults.adult')}}</p>
                                  <p class="mb-0 body-2-1 d-inline-block align-middle">{{detail_room_type.max_adults}} {{$t('hotel.room-type.guests')}}</p>
                                </div>
                                <div class="col-4" v-if="detail_room_type.max_children > 0">
                                  <p class="mb-0 body-3 lh-1">{{$t('hotel.children.children')}}</p>
                                  <p class="mb-0 body-2-1 d-inline-block align-middle">{{detail_room_type.max_children}} {{$t('hotel.room-type.guests')}}</p>
                                </div>
                                <div class="col-4" v-if="detail_room_type.max_infant > 0">
                                  <p class="mb-0 body-3 lh-1">{{$t('hotel.infants.infants')}}</p>
                                  <p class="mb-0 body-2-1 d-inline-block align-middle">{{detail_room_type.max_infant}} {{$t('hotel.room-type.guests')}}</p>
                                </div>
                              </div>
                              
                              <!-- FACILITIES -->
                              <div class="mb-4" v-if="detail_room_type.facility != 0 && detail_room_type.facility != undefined">
                                <p class="mb-2 body-3-3 text-16 font-bold">{{$t('hotel.room-type.room-facilities')}}</p>
                                <Facilities :facilities="detail_room_type.facility"></Facilities>
                              </div>

                              <template v-if="detail_room_type.policy != 0 && detail_room_type.policy != undefined">
                                <p class="pt-4 mb-2 body-3-3 text-16 font-bold">{{$t('hotel.room-policy')}}</p>
                                <div class="w-100">
                                  <ul class="pl-3">
                                    <li v-for="(policy, index) in detail_room_type.policy">
                                      <p class="mb-1 font-bold body-2-2 text-14">{{policy.title}}</p>
                                      <p class="mb-2 body-2-2 text-14 font-regular html-desc multiline-text" v-html="policy.description"></p>
                                    </li>
                                  </ul>
                                </div>
                              </template>
                            </div>
                          </div>
                          <div style="padding-bottom: 100px;"></div>
                        </div>
                        <div class="">
                          <div class="position-absolute w-100 z-index-1028" :class="{'bottom-0':detail_room_type.image == ''}" style="bottom:16px">
                            <div class="w-100 px-0">
                              <div class="row justify-content-center no-gutters">
                                <div class="col-12 position-relative">
                                  <div class="">
                                    <div class="w-100">
                                      <div class="container px-4 py-2 bg-white box-shadow-footer">
                                        <template>
                                          <div class="w-100 text-right mb-1 d-inline-block">
                                            <p
                                              class="mb-0 body-2-2 text-14 font-semibold d-inline-block float-left cursor-pointer">
                                              {{$t('hotel.starting-from')}} :</p>
                                            <p
                                              class="mb-0 body-2-2 text-16 font-bold text-orange d-block cursor-pointer">
                                              {{formatCurrency(detail_room_type.best_price.final_price)}}</p>
                                            <p class="mb-0 body-2 text-12 font-regular d-block">/ {{$t('hotel.unit-type.'+detail_room_type.type+'.per-unit-night')}}
                                            </p>
                                          </div>
                                        </template>
                                        <button type="button" class="button-secondary w-100"
                                          @click="onBack('detailRoom', false);onBack('handlePopupFilter', false)">
                                          {{$t('hotel.see-rates')}}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  import Flickity from 'vue-flickity';
  import {formatCurrency,formatDate} from '@/utils/index.js'
  import {mapGetters} from 'vuex'
  import Facilities from '@/components/hotel/facilities';
  import moment from 'moment'

  export default{
    props: ['detail_room','detail_room_type','popup_active','is_active'],
    components:{
      Flickity,
      Facilities
    },
    data(){
      return{
        more_policy: true,
        flickityOptionsRoom:{
          initialIndex: 0,
          prevNextButtons: false,
          pageDots: true,
          adaptiveHeight: false,
          draggable: false,
          wrapAround: true,
          autoPlay: 5000,
          pauseAutoPlayOnHover: false,
        },
      }
    },
    methods:{
      ...mapGetters(['getMerchant']),
      formatCurrency(data) {
        return formatCurrency(data)
      },
      onBack(type,data){
        this.$emit(type,data)
      },
      formatTime(time){
        return moment(time, 'HH:mm:ss').format('HH:mm')
      },
      isToggle(data){
        this.more_policy = data
      },
      slideTheSlider(action='next'){
        if(this.$refs.flickity){
          if(action === 'next') this.$refs.flickity.next();
          else this.$refs.flickity.previous();
        }
      }
    }
  }
</script>
<style scoped>
  .bottom-0{
    bottom: 0!important;
  }
  .bg-dark-transparent{
    background-color: rgb(35 35 35 / 88%)
  }
  .bg-blur-overlay{
    height: 90vh !important;
    filter:blur(10px);
    top:0px;
    left:0px;
    opacity:0.5;
    background-size:cover;
    background-position:center;
  }
</style>


// WEBPACK FOOTER //
// src/components/hotel/be/desktop/roomTypeDetail.vue